import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { api } from '@consts/url.const';
import { NotificationTemplatesModels } from '@models/notification-templates.model';

@Injectable({
  providedIn: 'root',
})

export class NotificationService {

  constructor(private http: HttpClient) {
  }

  public schedule(data: {
    notificationId: string;
    timeZone: string;
    schedule: string;
  }): Observable<any> {
    return this.http.post(api.notification.schedule, data);
  }

  public subscribeToWebPushNotifications(sub: PushSubscription) {
    return this.http.post(api.device.registerWeb, sub);
  }

  public listEmailTemplates(): Observable<NotificationTemplatesModels.NotificationTemplateCatalogItem[]> {
    return this.http.get<NotificationTemplatesModels.NotificationTemplateCatalogItem[]>(
      api.notificationTemplate.emailTemplates,
    );
  }

  public listSentNotifications(): Observable<NotificationTemplatesModels.SentNotificationHistoryRow[]> {
    return this.http.get<NotificationTemplatesModels.SentNotificationHistoryRow[]>(
      api.notificationTemplate.history,
    );
  }

  public sendNotification(
    data: NotificationTemplatesModels.SendNotificationRequest,
  ): Observable<NotificationTemplatesModels.SentNotificationHistoryRow> {
    return this.http.post<NotificationTemplatesModels.SentNotificationHistoryRow>(
      api.notificationTemplate.send,
      data,
    );
  }

  public previewNotificationTemplate(
    data: NotificationTemplatesModels.TemplatePreviewRequest,
  ): Observable<NotificationTemplatesModels.TemplatePreviewResponse> {
    return this.http.post<NotificationTemplatesModels.TemplatePreviewResponse>(
      api.notificationTemplate.preview,
      data,
    );
  }

}
